import Text from 'components/Text/Text';
import TerminalIdField from './components/TerminalIdField';
import React, { useContext } from 'react';
import {
	DeviceFullInfoContext,
	IDeviceFullInfoContext,
} from 'modules/Devices/DeviceFullInfo/deviceFullInfoState/deviceFullInfoContext';
import HardwareIdField from './components/HardwareIdField';
import CustomerField from './components/CustomerField';
import RestaurantField from './components/RestaurantField';
import PosField from './components/PosField';
import CreatedField from './components/CreatedField';
import UpdatedField from './components/UpdatedField';
import TableNumberField from './components/TableNumberField';
import BankSetting from './components/BankSettings/BankSetting';
import { UseTLSCertificateField } from './components/UseTLSCertificateField';
import { TlsCertificateNameField } from './components/TlsCertificateNameField';
import TLSInfo from './components/TLSInfo';
import style from './Info.module.scss';

const Info: React.FC = () => {
	const { deviceForFullInfo } = useContext<IDeviceFullInfoContext>(DeviceFullInfoContext);

	return (
		<div className={style.container} data-test="Info">
			<div className={style.fieldsWrapper}>
				<Text
					translationNameSpace="form"
					translationKey="infoHeading"
					theme="secondary"
					size="l"
					weight="bold"
				/>
				<HardwareIdField />
				<CustomerField />
				<RestaurantField />
				<PosField />
				<TerminalIdField />
			</div>
			<div className={style.fieldsWrapper}>
				<Text
					translationNameSpace="form"
					translationKey="updateInfoHeading"
					theme="secondary"
					size="l"
					weight="bold"
				/>
				<CreatedField />
				<UpdatedField />
			</div>
			<div className={style.fieldsWrapper}>
				<Text
					translationNameSpace="form"
					translationKey="additionalInfoHeading"
					theme="secondary"
					size="l"
					weight="bold"
				/>
				<TableNumberField />
			</div>
			<div className={style.fieldsWrapper}>
				<Text
					translationNameSpace="form"
					translationKey="bankSettingsHeading"
					theme="secondary"
					size="l"
					weight="bold"
				/>
				<BankSetting />
			</div>
			<div className={style.fieldsWrapper}>
				<Text
					translationNameSpace="form"
					translationKey="clientTLSCertificateHeading"
					theme="secondary"
					size="l"
					weight="bold"
				/>
				<UseTLSCertificateField />
				<TlsCertificateNameField />
				<TLSInfo />
			</div>
		</div>
	);
};

export default Info;
